import Swiper from 'swiper';
import { Pagination, Navigation } from 'swiper/modules';
import { $Q } from '../utils/query-selector';
import 'swiper/css/bundle';
import "../scss/components/_slider-reviews.scss";

const initLPReviews = () => {
  const sliderReviews = $Q('.lp-reviews');

  if (!sliderReviews) return;
  new Swiper(sliderReviews, {
    modules: [Pagination, Navigation],
    slidesPerView: "auto",
    spaceBetween: 16,
    loop: false,
    breakpoints: {
      992: {
        spaceBetween: 24,
      }
    },
    pagination: {
      el: '.swiper-pagination',
      clickable: true
    },
    navigation: {
      nextEl: '.swiper-button--next' || null,
      prevEl: '.swiper-button--prev' || null,
    },
    autoplay: false
  });
};

export default initLPReviews;
